"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageSizeFromImageElement = void 0;
var rect_size_1 = require("../../types/record/rect-size");
var getImageSizeFromImageElement = function (imgElement) {
    return (0, rect_size_1.IRectSize)({
        height: imgElement.naturalHeight,
        width: imgElement.naturalWidth
    });
};
exports.getImageSizeFromImageElement = getImageSizeFromImageElement;
